import { render } from "./LocateList.vue?vue&type=template&id=4bc318e2"
import script from "./LocateList.vue?vue&type=script&lang=js"
export * from "./LocateList.vue?vue&type=script&lang=js"

import exportComponent from "/home/smartphone/public_html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__